// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Беклоги» (Backlogs, ключ `bkl`, група `management`). */
export const backlogsManifest: IModuleManifest = {
  key: 'bkl',
  group: 'management',
  slug: 'backlogs',
  prefix: 'BKL',
  name: { en: 'Backlogs', uk: 'Беклоги' },
  entities: [
    { key: 'bkl', slug: 'bkl', name: { en: 'Backlogs', uk: 'Беклоги' }, main: true },
    { key: 'backlog_item', slug: 'backlog-item', name: { en: 'Backlog Items', uk: 'Елементи' }, main: false },
    { key: 'backlog_priority', slug: 'backlog-priority', name: { en: 'Backlog Priorities', uk: 'Пріоритети' }, main: false },
  ],
  loadState: () => import('./state/backlogsSlice').then((m) => m.backlogsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
